export default __webpack_public_path__ + "static/media/experience-banner.9b2c1e41.png";